import { useState, useEffect } from "react";
import { loadMaterialSubCategoryList } from "../services/materialCategory";
const useMaterialSubCategory = (editID) => {

    const [materialSubCategory, setMaterialSubCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedSubCategoryID, setSelectedSubCategoryID] = useState(null);
    const [isMaterialSubCategoryDataLoaded, setIsMaterialSubCategoryDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialSubCategory = async (selectedCategoryID = null, selectedSubCategoryID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1, 
            p_id_category: selectedCategoryID || 0,           
        };

        try {
            const data = await loadMaterialSubCategoryList(para);
            if (data && data.length > 0) {
                setMaterialSubCategory(data);

                if (selectedCategoryID === 0) {
                    setSelectedSubCategory([]);
                    setSelectedSubCategoryID([]);
                }
                else {
                    const initialMaterialCategory = data.find((dept) => dept.id_material_subcategory === selectedSubCategoryID);
                    // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                    if (initialMaterialCategory) { // ✅ Corrected check
                        setSelectedSubCategory(initialMaterialCategory);
                        setSelectedSubCategoryID(initialMaterialCategory.id_material_subcategory);
                    }
                }
                setIsMaterialSubCategoryDataLoaded(true);
            }
            else {
                setMaterialSubCategory([]);
                setSelectedSubCategory(null);
                setSelectedSubCategoryID(null);
                setIsMaterialSubCategoryDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialSubCategoryDataLoaded && editID === 0) {
            fetchMaterialSubCategory();
        }
    }, [isMaterialSubCategoryDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMaterialSubCategoryByID = async (selectedCategoryID , selectedSubCategoryID) => {
        await fetchMaterialSubCategory(selectedCategoryID, selectedSubCategoryID);
    };

    return {
        materialSubCategory,
        selectedSubCategory,
        selectedSubCategoryID,
        setSelectedSubCategory,
        setSelectedSubCategoryID,
        loadMaterialSubCategoryByID,
    };
};

export default useMaterialSubCategory;
